import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, OnChanges } from '@angular/core';

import { GlobalConstants } from '../../../common/constants/global.constant';

@Component({
  selector: 'iposcen-create-custom-installation-package',
  templateUrl: './create-custom-installation-package.component.html',
  styleUrls: ['./create-custom-installation-package.component.scss']
})
export class CreateCustomInstallationPackageComponent implements OnInit, OnChanges {
  @Output() readonly sideNav = new EventEmitter();
  @Output() readonly scrollDone = new EventEmitter();
  @Input() sideNavData;
  @Input() helpToAsset;
  @ViewChild('customPackage') generate: ElementRef;
  @ViewChild('custTop') customTop: ElementRef;
  @ViewChild('profileInfo') profileInfo: ElementRef;
  @ViewChild('StoreLogo') storeLogo: ElementRef;
  @ViewChild('promoContent') promoContent: ElementRef;
  @ViewChild('segment') segment: ElementRef;
  @ViewChild('customBanner') banner: ElementRef;
  @ViewChild('priceContent') price: ElementRef;
  @ViewChild('factTag') factTag: ElementRef;
  @ViewChild('setting') setting: ElementRef;
  @ViewChild('mainTile') mainTile: ElementRef;
  loginUserRole = sessionStorage.getItem('userRole');
  retailHQUser = GlobalConstants.RETAIL_HQ_USER;
  storeUser = GlobalConstants.STORE_USER;
  intelAdmin = GlobalConstants.INTEL_ADMIN;
  nonConnectedUser = GlobalConstants.NON_CONNECTED_USER;
  isProfileInfo = true;
  isStoreLogo = true;
  isPromoContent = true;
  isSegment = true;
  isBannerCarousel = true;
  isPriceContent = true;
  isFactTag = true;
  isSettings = true;
  isMainTileAsset = true;
  isGeneratePackage = true;
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.helpToAsset === 'generate') {
      setTimeout(() => {
        this.generate.nativeElement.scrollIntoView();
      }, 0);
    } else if (this.helpToAsset === 'fact') {
      setTimeout(() => {
        this.factTag.nativeElement.scrollIntoView();
      }, 100);
    }

  }

  change(data){
    if (data === 'profileInfo') {
      setTimeout(() => {
        this.profileInfo.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'storeLogo') {
      setTimeout(() => {
        this.storeLogo.nativeElement.scrollIntoView();
      }, 0);

    } else if (data === 'promoContent') {
      setTimeout(() => {
        this.promoContent.nativeElement.scrollIntoView();

      }, 0);

    } else if (data === 'segment') {
      setTimeout(() => {
        this.segment.nativeElement.scrollIntoView();
      }, 0);

    } else if (data === 'banner') {
      setTimeout(() => {
        this.banner.nativeElement.scrollIntoView();
      }, 0);

    } else if (data === 'price') {
      setTimeout(() => {
        this.price.nativeElement.scrollIntoView();
      }, 0);

    } else if (data === 'factTag') {
      setTimeout(() => {
        this.factTag.nativeElement.scrollIntoView();
      }, 0);

    } else if (data === 'setting') {
      setTimeout(() => {
        this.setting.nativeElement.scrollIntoView();
      }, 0);

    } else if (data === 'mainTile') {
      setTimeout(() => {
        this.mainTile.nativeElement.scrollIntoView();
      }, 0);

    } else if (data === 'generate') {
      setTimeout(() => {
        this.generate.nativeElement.scrollIntoView();
      }, 0);
    } else {
      setTimeout(() => {
        this.customTop.nativeElement.scrollIntoView();
      }, 0);

    }
  }
  navigate(data, section) {
    this.sideNav.emit([data, '', section]);
  }
  showDescription(data) {
    if (data === 'toggleProfileInfo') {
      this.isProfileInfo = !this.isProfileInfo;
    } else if (data === 'toggleStoreLogo') {
      this.isStoreLogo = !this.isStoreLogo;
    } else if (data === 'togglePromoContent') {
      this.isPromoContent = !this.isPromoContent;
    } else if (data === 'toggleisSegemt') {
      this.isSegment = !this.isSegment;
    } else if (data === 'toggleBannerCarousel') {
      this.isBannerCarousel = !this.isBannerCarousel;
    } else if (data === 'toggleFactTag') {
      this.isFactTag = !this.isFactTag;
    } else if (data === 'togglePriceContent') {
      this.isPriceContent = !this.isPriceContent;
    } else if (data === 'toggleMainTile') {
      this.isMainTileAsset = !this.isMainTileAsset;
    } else if (data === 'toggleGeneratePackage') {
      this.isGeneratePackage = !this.isGeneratePackage;
    } else if (data === 'toggleSettings') {
      this.isSettings = !this.isSettings;
    }

  }
}
